
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
    name: 'PaymentOfferDeleteButton',
})
export default class PaymentOfferDeleteButton extends Vue {}
